import React,{useContext,useState} from 'react'
import styled from '@emotion/styled';
import { ModalContainer,IconContainer,UIcon,SubmitContainer,StyleButton } from '../Modal/CreateAdminUser';
import { useModal } from '../../../../hooks/Context';
import { apiRequest,apiFormRequest } from '../../../../api';
import { useQueryClient,useMutation } from '@tanstack/react-query';
import { NotificationContext } from '../../../../providers/notification';
import { useSettingModal } from '../../../../hooks/Context';
import {SettingContextI} from '../../../../types';

const DisableAdmin = (props:any) => {
  const {setShowModal}:SettingContextI = useSettingModal();
  const data = props?.data;
  const [loadBtn,setLoadBtn] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const {showNotification} = useContext(NotificationContext);

  const submitDisable = async() =>{
    let body:any = new FormData();
    body.append('Id',data.Id);
    return await apiFormRequest('api/SetUp/DeleteClassificationById',body,"DELETE");
  }
  const disableAdiminMutation = useMutation(submitDisable,{
    onSuccess(data, variables, context) {
      showNotification({message:data.Message || 'Classification Deleted Successfully',
      type:'success'})
      queryClient.invalidateQueries(['all-CompanyClass']);
    },
    onError(error:any){
        showNotification({message:error.Message || 'Classification Cannot be deleted',
      type:'error'})
    },
    onSettled(data, error, variables, context) {
        setShowModal(false);
        setLoadBtn(false);
    },
  })
  const handleDeleteClass = (e:any) =>{
    e.preventDefault();
    setLoadBtn(true);
    disableAdiminMutation.mutate();
  }
  return (
    <ModalContainer style={{width:'400px',borderRadius:'8px'}}>
        <div>
          <div style={{borderRadius:'8px 8px 0 0'}}>
            <div>
              <IconContainer><UIcon /></IconContainer>
              <span>Delete Classification</span>
            </div>
          </div>
          <Wrapper onSubmit={handleDeleteClass}>
            <p>
             You are about to delete Classification  <span style={{fontWeight:'bold'}}>{data.ClassificationType} in {data.SectorType} Sector?</span>
            </p>
            <SubmitContainer>
            <span style={{cursor:"pointer"}} 
              onClick={()=> setShowModal(false)}>Cancel</span>
             <StyleButton style={{backgroundColor:'#DD5151',color:'#fff'}}>
              {loadBtn?'Loading...':'Yes, Delete'}
            </StyleButton> 
            
          </SubmitContainer>


          </Wrapper>
        </div>

    </ModalContainer>
  )
}

export default DisableAdmin;

const Wrapper = styled.form`
  min-height:200px;
  display:flex;
  flex-direction:column;
  gap: 20px;
  padding:20px;
  border-radius:0 0 8px 8px;
  
`